import { IconPropsType } from '..';

export const BackofficeLogoIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="25"
    height="19"
    viewBox="0 0 25 19"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.55787 4.88386H0L7.56023 18.5117L9.7734 14.3199L4.55787 4.88386Z"
      fill="url(#paint0_linear_438_12608)"
    />
    <path
      d="M17.8998 0H13.3419L5.28416 14.3999L7.54307 18.5117L10.4368 13.3362L12.7071 9.25299L14.9775 13.3362H17.8998C21.474 13.3362 24.3677 10.3739 24.3677 6.69098C24.3677 3.00808 21.4683 0 17.8998 0ZM17.8998 9.25299H12.7186L15.6123 4.07749H17.8941C19.2895 4.07749 20.4218 5.24984 20.4218 6.68526C20.4218 8.12067 19.2895 9.25299 17.8941 9.25299H17.8998Z"
      fill="url(#paint1_linear_438_12608)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_438_12608"
        x1="21.8582"
        y1="16.4531"
        x2="16.3095"
        y2="-2.9545"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E9E9EC" />
        <stop
          offset="0.3"
          stopColor="#E3E3E7"
        />
        <stop
          offset="0.7"
          stopColor="#D3D3DA"
        />
        <stop
          offset="1"
          stopColor="#C2C2CC"
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_438_12608"
        x1="14.8231"
        y1="16.4701"
        x2="14.8231"
        y2="2.24748"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C2C2CC" />
        <stop
          offset="0.2"
          stopColor="#CDCDD5"
        />
        <stop
          offset="0.7"
          stopColor="#E1E1E5"
        />
        <stop
          offset="1"
          stopColor="#E9E9EC"
        />
      </linearGradient>
    </defs>
  </svg>
);
